"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _InstrumentSelectorComponent = _interopRequireDefault(require("./InstrumentSelectorComponent"));
var _instrumentActions = require("../../redux/actions/instrumentActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _selectors = require("../../redux/margin/selectors");
var _marginInstrumentSelectors = require("../../redux/margin/selectors/marginInstrumentSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedAccountId = (0, _selectors.selectedAccountIdSelector)(state);
  var isMarginActive = (0, _selectors.isMarginActiveSelector)(state);
  var isInstrumentsFetching = state.apexCore.instrument.fetching;
  var isMarginInstrumentsFetching = state.margin.instrument.fetching || isInstrumentsFetching;
  var fetching = isMarginActive ? isMarginInstrumentsFetching : isInstrumentsFetching;
  var instruments = isMarginActive ? (0, _marginInstrumentSelectors.instrumentSelectorMarginInstruments)(state) : (0, _instrumentPositionSelectors.instrumentSelectorEnabledInstruments)(state);
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  return {
    level1: state.apexCore.level1,
    instruments: instruments,
    selectedAccountId: selectedAccountId,
    selectedInstrument: selectedInstrument,
    selectedRow: {
      key: 'InstrumentId',
      value: selectedInstrument.InstrumentId
    },
    fetching: fetching
  };
};
var mapDispatchToProps = {
  selectInstrument: _instrumentActions.selectInstrument
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InstrumentSelectorComponent["default"]);